import AxiosAPI from '../../utils/AxiosAPI';

export const handleNewAddSubscriptionOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/`)
            .post({ ...formData, ProductId: formData.ProductId || 0 })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleGetSubscriptionsOpe = (params) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/`, {
                q: params.q || '',
                applications: params.applications || '',
                limitby: params['limit-by'] || '',
                status: params.status || '',
                orderby: params['order-by'] || 'id',
                sort: params.sort || 'desc',
                page: params.page || 1,
                cpp: 12
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export const handleGetPendingSubscriptionsOpe = () =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/pending`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleLoadLicenseKey = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/subscriptions/${id}/license/show-code`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
